export const extractPrimaryLanguage = (lang) => {
  const supportedLanguages = ['de', 'en', 'fr'];
  // Split by any underscores or hyphens and return the first part
  const parts = lang.split(/[_-]/);
  const extractedLang = parts[0].toLowerCase();

  return supportedLanguages.includes(extractedLang) ? extractedLang : 'de';
};

export const getLocale = () => {
  const htmlLang = document.documentElement.lang;
  const locale = new Intl.Locale(extractPrimaryLanguage(htmlLang) || 'de');

  return locale;
};

export const getLang = () => getLocale().language;
